module.exports = __webpack_public_path__ + "img/star.5b9f6f85.png";